import {NgModule} from "@angular/core";
import {RouterModule, Routes} from "@angular/router";
import {HomeComponent} from "./home/home.component";
import {NotFoundComponent} from "./core/not-found/not-found.component";
import {ArchiveComponent} from "./home/highlights/archive/archive.component";

const routes: Routes = [
  {
    path: 'content',
    loadChildren: () => import('app/content/content.module').then(m => m.ContentModule),
    data: {page: "content"}
  },
  {
    path: 'home',
    component: HomeComponent,
    data: {page: 'home'}
  },
  {path: 'archive', component: ArchiveComponent, data: {page: "archive"}},
  {path: '', component: HomeComponent, data: {page: "home"}},
  {path: '', redirectTo: '/', pathMatch: 'full', data: {page: "home"}},
  {path: '404', component: NotFoundComponent},
  {path: '**', redirectTo: '/404'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
